(function (root) {
  'use strict';
  var busy = false;

  function buildLines(config, quantity, cart, sellingPlan) {
    if (!config || config.sku !== 'SW10050' || !config.variantId) {
      throw new Error('Die Einzelpackung ist gerade nicht verfügbar.');
    }
    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      throw new Error('Bitte wähle eine gültige Packungsanzahl.');
    }
    var line = { id: config.variantId, quantity: quantity };
    if (sellingPlan) line.selling_plan = sellingPlan;
    var lines = [line];
    if (config.includeStarterGift) {
      if (quantity !== 4 || sellingPlan) throw new Error('Das Kennenlern-Angebot ist nicht verfügbar.');
      if (!config.giftVariantId || config.giftPrice !== 0) throw new Error('Die Gratis-Tasche ist gerade nicht verfügbar.');
      var hasGift = (cart.items || []).some(function (item) {
        return String(item.variant_id) === String(config.giftVariantId);
      });
      if (!hasGift) lines.push({ id: config.giftVariantId, quantity: 1, properties: { _starter_gift: 'true' } });
    }
    return lines;
  }

  function jsonRequest(url, options) {
    return root.fetch(url, options).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.description || 'Der Artikel konnte nicht hinzugefügt werden.');
        return body;
      });
    });
  }

  function start(event) {
    if (event) event.preventDefault();
    if (busy) return Promise.resolve();
    busy = true;
    var button = event && event.target && event.target.closest('button');
    var label = button && button.textContent;
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt…'; }
    var config = root.ppSingleSkuConfig;
    var path = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    return jsonRequest(path + 'cart.js', { cache: 'no-store' }).then(function (cart) {
      var items = buildLines(config, 4, cart);
      return jsonRequest(path + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
      });
    }).then(function () {
      if (typeof root.ppCartDrawerOpen === 'function') root.ppCartDrawerOpen();
      else root.location.href = path + 'cart';
    }).catch(function (error) {
      root.alert(error.message || 'Bitte versuche es erneut.');
    }).finally(function () {
      busy = false;
      if (button) { button.disabled = false; button.textContent = label; }
    });
  }

  root.ppSingleSku = { buildLines: buildLines };
  root.ppStartKennenlernangebot = start;
})(window);
